// Turbo macht das scrollen in Firefox kaputt, Lösung:
document.addEventListener(`turbo:before-visit`, () => {
  document.documentElement.style.scrollBehavior = `unset`
})

document.addEventListener(`turbo:load`, () => {
  document.documentElement.style.scrollBehavior = `smooth`
})
